import {
  SET_LAST_OPEN_TIME_FOR_CONVERSATION
} from '../action_types'

export default (conversationId, time) => {
  return {type: SET_LAST_OPEN_TIME_FOR_CONVERSATION, conversationId, time}
}


/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/set_last_open_time_for_conversation.js
 **/